// extracted by mini-css-extract-plugin
export default {"modal":"float-menu_modal__Z0IFm","modalContent":"float-menu_modalContent__kL2JA","modalButton":"float-menu_modalButton__fCDv1"};